import { useState } from "react";
import { FiUser } from "react-icons/fi";
import { FormattedDate, FormattedMessage } from "react-intl";
import dayjs from "../../../mydayjs";
import CurrencyNumber from "../../cmp/CurrencyNumber";
import AffiliateSalesLineItemsModal from "../home/AffiliateSalesLineItemsModalNew";

export function getComponent(eventType, entityType) {
  const key = `${entityType}-${eventType}`;
  switch (key) {
    case "orders-delete":
      return OrderDeleted;
    case "orders-update":
      return OrderUpdated;
    case "orders-insert":
      return OrderInserted;
    case "payouts-insert":
      return PayoutInserted;
    case "payouts-update":
      return PayoutUpdated;
    case "payouts-delete":
      return PayoutDeleted;
    case "rewards-insert":
      return RewardInserted;
    case "rewards-update":
      return RewardUpdated;
    case "rewards-delete":
      return RewardDeleted;
    default:
      return null;
  }
}
function RenderOrderStatus({ status }) {
  switch (status) {
    case "rejected":
      return (
        <span className="badge badge-sm badge-danger">
          <FormattedMessage id={"Rejected"} />
        </span>
      );
    case "new":
      return (
        <span className="badge badge-sm badge-warning">
          {" "}
          <FormattedMessage id={"Pending"} />{" "}
        </span>
      );
    case "approved":
      return (
        <span className="badge badge-sm badge-success">
          {" "}
          <FormattedMessage id={"Approved"} />{" "}
        </span>
      );
    case "deleted":
      return (
        <span className="badge badge-sm badge-danger">
          {" "}
          <FormattedMessage id={"Deleted"} />{" "}
        </span>
      );
    default:
      return null;
  }
}

function OrderDeleted({ metadata }) {
  const { order_number, affiliate_commission, status } = metadata;
  const deltas = [];
  if (affiliate_commission !== 0 && status === "approved") {
    deltas.push(
      <div>
        <FormattedMessage id={"Delta Commission"} />{" "}
        <CurrencyNumber value={affiliate_commission} /> →{" "}
        <CurrencyNumber value={0} />
      </div>,
    );
  }
  deltas.push(
    <div>
      <FormattedMessage id={"Delta Status"} />{" "}
      <RenderOrderStatus status={status} /> →{" "}
      <RenderOrderStatus status={"deleted"} />
    </div>,
  );

  return (
    <>
      <span className="text-danger">
        {order_number}
        <br />
      </span>
      <small>{deltas}</small>
    </>
  );
}
function OrderInserted({ metadata, entity_id }) {
  const { order_number, affiliate_commission, status } = metadata;
  const [orderId, setOrderId] = useState(null);

  return (
    <>
      <AffiliateSalesLineItemsModal
        onClose={() => setOrderId(null)}
        order_id={orderId}
      />
      <button
        className={"btn btn-link p-0"}
        onClick={() => setOrderId(entity_id)}
      >
        {order_number}{" "}
        {status !== "approved" ? <RenderOrderStatus status={status} /> : null}
      </button>
    </>
  );
}
function OrderUpdated({ metadata, onShowEventLog }) {
  const { order_number, affiliate_commission, status } = metadata;
  const {
    new_status,
    old_status,
    new_affiliate_commission,
    old_affiliate_commission,
  } = metadata;
  const deltas = [];
  if (new_affiliate_commission !== old_affiliate_commission) {
    deltas.push(
      <div>
        <FormattedMessage id={"Delta Commission"} />{" "}
        <CurrencyNumber value={old_affiliate_commission} /> →{" "}
        <CurrencyNumber value={new_affiliate_commission} />
      </div>,
    );
  }
  if (new_status !== old_status) {
    deltas.push(
      <div>
        <FormattedMessage id={"Delta Status"} />{" "}
        <RenderOrderStatus status={old_status} /> →{" "}
        <RenderOrderStatus status={new_status} />
      </div>,
    );
  } else {
    deltas.push(
      <div>
        <FormattedMessage id={"Status"} />:{" "}
        <RenderOrderStatus status={new_status} />
      </div>,
    );
  }

  return (
    <>
      <button className="px-0 py-0 btn text-warning" onClick={onShowEventLog}>
        {order_number}
      </button>
      <small>
        <br />
        {deltas}
      </small>
    </>
  );
}

function PayoutDeleted({ metadata }) {
  const { payment_method } = metadata;
  return (
    <span className="text-danger">
      <FormattedMessage id={"Payout deleted"} />
    </span>
  );
}
function PayoutInserted({ metadata }) {
  const { payment_method } = metadata || {};
  return (
    <span>
      <FormattedMessage id={"Payout Inserted"} defaultMessage={"Payout"} />
    </span>
  );
}
function PayoutUpdated() {}
function RewardDeleted({ metadata }) {
  const { order_number } = metadata;
  return (
    <span className={"text-danger"}>
      <FormattedMessage id={"Deleted"} /> {order_number}
    </span>
  );
}
function RewardInserted({ metadata }) {
  const {
    reward_data,
    status,
    reward_type,
    created,
    order_number,
    downline,
    commission_on,
  } = metadata;
  switch (reward_type) {
    case "wallet_adjustment":
      return (
        <span>
          {reward_data ? (
            <div>{reward_data}</div>
          ) : (
            <div>
              <FormattedMessage id={"Wallet Adjustment"} />
            </div>
          )}
          {created ? (
            <small>
              <FormattedDate
                value={created || new Date()}
                month={"short"}
                day={"numeric"}
              />
            </small>
          ) : null}
        </span>
      );
    case "sale_commission":
      return (
        <span>
          <FormattedMessage id={"Network commission"} />
          <br />
          {downline && downline?.name ? (
            <small className={"d-block downline_name"}>
              <FiUser /> {downline?.name}
            </small>
          ) : null}
          <small>
            {order_number} (<CurrencyNumber value={commission_on} />
            )&nbsp;
            {status !== "approved" ? (
              <RenderOrderStatus status={status} />
            ) : null}
          </small>
        </span>
      );
    case "signup_bonus":
      return (
        <span>
          <FormattedMessage id={"Signup Bonus"} />
        </span>
      );
    case "recruitment_bonus":
      return (
        <span>
          <FormattedMessage id={"Recruitment Bonus"} />
        </span>
      );
    case "target_bonus":
      if (typeof reward_data === "string") {
        return <span>{reward_data}</span>;
      }
      return (
        <span>
          <FormattedMessage id={"Target Bonus"} />
        </span>
      );
    case "compensation_plan":
      const [, month, year] = String(reward_data.split(":").slice(-1)).split(
        "-",
      );
      let time = "";
      if (month && year) {
        time = (
          <FormattedDate
            value={dayjs().month(month).year(year).startOf("day").toDate()}
            month={"short"}
            year={"numeric"}
          />
        );
      }
      return (
        <span>
          {metadata?.details?.name || <FormattedMessage id={"Monthly Bonus"} />}
          {time ? (
            <>
              <small>
                <br />
                {time}
              </small>
            </>
          ) : (
            ""
          )}
        </span>
      );
    default:
      return reward_type;
  }
}

function RewardUpdated({ metadata, onShowEventLog }) {
  const { order_number, affiliate_commission, status, created, reward_data } =
    metadata;
  const {
    new_status,
    old_status,
    reward_type,
    new_affiliate_commission,
    old_affiliate_commission,
  } = metadata;
  if (reward_type === "compensation_plan") {
    const [, month, year] = String(reward_data.split(":").slice(-1)).split("-");
    let time = "";
    if (month && year) {
      time = (
        <FormattedDate
          value={dayjs().month(month).year(year).startOf("day").toDate()}
          month={"short"}
          year={"numeric"}
        />
      );
    }
    return (
      <button className={"btn p-0 text-start"} onClick={onShowEventLog}>
        <span className="text-warning">
          {metadata?.details?.name || <FormattedMessage id={"Monthly Bonus"} />}
        </span>
        {time ? (
          <>
            <small>
              <br />
              {time}
            </small>
          </>
        ) : (
          ""
        )}
      </button>
    );
  }
  if (reward_type === "wallet_adjustment") {
    return (
      <div>
        <FormattedMessage id={"Wallet Adjustment"} />
        <br />
        <div className={"text-muted"}>{reward_data}</div>
        <small>
          <FormattedMessage id={"Date"} />:{" "}
          <FormattedDate
            value={created || new Date()}
            month={"short"}
            day={"numeric"}
          />
        </small>
      </div>
    );
  }

  const deltas = [];
  if (new_affiliate_commission !== old_affiliate_commission) {
    deltas.push(
      <div>
        <FormattedMessage id={"Delta Commission"} />{" "}
        <CurrencyNumber value={old_affiliate_commission} /> →{" "}
        <CurrencyNumber value={new_affiliate_commission} />
      </div>,
    );
  }
  if (new_status !== old_status) {
    deltas.push(
      <div>
        <FormattedMessage id={"Delta Status"} />{" "}
        <RenderOrderStatus status={old_status} /> →{" "}
        <RenderOrderStatus status={new_status} />
      </div>,
    );
  } else {
    deltas.push(
      <div>
        <FormattedMessage id={"Status"} />:{" "}
        <RenderOrderStatus status={new_status} />
      </div>,
    );
  }

  return (
    <>
      <button className="btn px-0 text-warning" onClick={onShowEventLog}>
        <FormattedMessage id={"Network Commission"} /> {order_number}
      </button>
      <small>
        <br />
        {deltas}
      </small>
    </>
  );
}
